import { Button, Form, Input, notification, Select } from '@pankod/refine-antd';
import { IResourceComponentsProps, useSelect } from '@pankod/refine-core';
import { getSubscriptionPool } from 'apis/contributorSubscriptionPool/getSubscriptionPool';
import { getCheckInfoTrack, getJobs, startJob } from 'apis/job';
import React, { useCallback, useEffect, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import { IUser } from 'types/user.interface';
import { formatDateTime } from 'utils';

export const JobPage: React.FC<IResourceComponentsProps> = () => {
    const [labelId, setLabelId] = useState('');
    const [contributorId, setContributorId] = useState('');
    const [userId, setUserId] = useState('');
    const [downloadRemaining, setDownloadRemaining] = useState<number | undefined>();
    const [isLoadingDownloadRemaining, setIsLoadingDownloadRemaining] = useState(false);

    const [quantity, setQuantity] = useState();
    const [jobs, setJobs] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);

    const [subscriptionPool, setSubscriptionPool] = useState<any>(null);

    const getDataSubscriptionPool = async () => {
        const data = await getSubscriptionPool();
        setSubscriptionPool(data?.[0]);
    };

    useEffect(() => {
        getDataSubscriptionPool();
    }, []);

    const handleGetCheckInfoTrack = useCallback(async () => {
        if (!labelId || !contributorId || !userId) return;

        setIsLoadingDownloadRemaining(true);
        try {
            const res = await getCheckInfoTrack({
                labelId,
                contributorId,
                userId,
            });
            setDownloadRemaining(res.data);
        } catch (error) {
            console.error('Error fetching download remaining:', error);
            setDownloadRemaining(0);
        } finally {
            setIsLoadingDownloadRemaining(false);
        }
    }, [contributorId, labelId, userId]);

    useEffect(() => {
        handleGetCheckInfoTrack();
    }, [handleGetCheckInfoTrack]);

    const handleStartJob = useCallback(async () => {
        const data = {
            labelId,
            contributorId,
            userId,
            quantity,
        };
        try {
            setIsLoading(true);
            const res = await startJob(data);
            if (res?.data) {
                setJobs([res?.data, ...jobs]);
            }

            setIsLoading(false);
            notification.open({
                type: 'success',
                message: 'Notification',
                description: 'Create job successfully',
            });
        } catch (error: any) {
            setIsLoading(false);
            notification.open({
                type: 'error',
                message: 'Notification',
                description: error?.message,
            });
        }
    }, [contributorId, jobs, labelId, quantity, userId]);

    const handleGetJobs = useCallback(async () => {
        const res = await getJobs();
        setJobs(res?.data);
    }, []);

    useEffect(() => {
        handleGetJobs();
    }, [handleGetJobs]);

    const { options: optionsContributors } = useSelect<IUser>({
        resource: 'users/contributor',
        optionLabel: 'username',
        optionValue: '_id',
    });

    const { options: optionsUsers } = useSelect<IUser>({
        resource: 'users/job',
        optionLabel: 'username',
        optionValue: '_id',
    });

    const { options } = useSelect<any>({
        resource: 'labels',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const handleChangeLabel = (value: any) => {
        setLabelId(value);
    };

    const handleChangeUser = (value: any) => {
        setUserId(value);
    };

    const handleChangeContributors = (value: any) => {
        setContributorId(value);
    };

    return (
        <div
            style={{
                marginBottom: '15px',
                background: '#FFFFFF',
                padding: '20px',
                borderRadius: '5px',
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <Form.Item label='Contributors'>
                        <Select
                            placeholder='Select contributors'
                            showSearch
                            filterOption={(input, option: any) => option.label.toLowerCase().includes(input.toLowerCase())}
                            options={optionsContributors}
                            style={{ width: '200px' }}
                            onChange={(e) => handleChangeContributors(e)}
                        />
                    </Form.Item>
                </div>
                <div>
                    <Form.Item label='User'>
                        <Select
                            placeholder='Select user'
                            showSearch
                            filterOption={(input, option: any) => option.label.toLowerCase().includes(input.toLowerCase())}
                            options={optionsUsers}
                            style={{ width: '200px' }}
                            onChange={(e) => handleChangeUser(e)}
                        />
                    </Form.Item>
                </div>
                <div>
                    <Form.Item label='Label'>
                        <Select placeholder='Select label' style={{ width: '200px' }} options={[...options]} onChange={handleChangeLabel} />
                    </Form.Item>
                </div>
                <div>
                    <Form.Item label='Quantity'>
                        <Input onChange={(e: any) => setQuantity(e.target.value)} style={{ width: '200px' }} placeholder='Enter quantity' />
                    </Form.Item>
                </div>
            </div>
            {(downloadRemaining !== undefined || (labelId && contributorId && userId)) && (
                <p style={{ fontSize: '15px', color: '#000', fontWeight: 600 }}>This Job has {isLoadingDownloadRemaining ? '...' : downloadRemaining ?? 0} downloads remaining</p>
            )}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button loading={isLoading} onClick={handleStartJob}>
                    Start
                </Button>
            </div>

            <div style={{ marginTop: '20px' }}>
                <p style={{ fontWeight: 600, fontSize: '14px', color: '#000' }}>List Job:</p>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ padding: '8px', color: '#000' }}>Label</th>
                            <th style={{ padding: '8px', color: '#000' }}>User</th>
                            <th style={{ padding: '8px', color: '#000' }}>Contributor</th>
                            <th style={{ padding: '8px', color: '#000' }}>Progress</th>
                            <th style={{ padding: '8px', color: '#000' }}>$ in return</th>
                            <th style={{ padding: '8px', color: '#000' }}>Completed At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map((row: any, index: any) => (
                            <tr key={index}>
                                <td style={{ padding: '8px', textAlign: 'center' }}>{row?.label?.name}</td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>{row?.user.username}</td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>{row?.contributor.username}</td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>
                                    <a href={`/job/edit/${row._id}`} target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none', color: 'blue' }}>
                                        {`${row?.tracks.length} / ${row?.quantity}`}
                                    </a>
                                </td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>
                                    ${((row?.perDownloadValue || subscriptionPool?.perDownloadValue || 0) * (row?.tracks.length || 0)).toFixed(2)}
                                </td>
                                <td style={{ padding: '8px', textAlign: 'center' }}>{row.isNeedProcess ? 'RUNNING' : formatDateTime(row?.updatedAt)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
